import React, { useContext, useEffect, useState } from 'react';
import About from './About';
import LanguagePicker from './LanguagePicker';
import { ModalContext } from '../providers/ModalProvider';
import MoldContainer from './MoldContainer';
import PropTypes from 'prop-types';
import { SIDE } from '../helpers/consts-and-types';
import { molds } from '../helpers/all-molds';
import { normalizeString } from '../helpers/string';
import styles from './Molds.module.scss';
import useLocalize from '../hooks/use-localize';

const Molds = ({ setCrustRatio, setRatio }) => {
  const { localize } = useLocalize();

  const [volumeLeft, setVolumeLeft] = useState(0);
  const [volumeRight, setVolumeRight] = useState(0);

  const [crustVolumeLeft, setCrustVolumeLeft] = useState(0);
  const [crustVolumeRight, setCrustVolumeRight] = useState(0);

  const showModal = useContext(ModalContext);

  // Initialization
  useEffect(() => {
    // Normalize all titles
    molds.forEach((mold) => {
      mold.normalizedTitle = normalizeString(mold.title);
      mold.isSelected = false;
    });
  }, []);

  useEffect(() => {
    if (volumeLeft > 0 && volumeRight >= 0) {
      setRatio(Math.max(volumeRight / volumeLeft, 0.01));
    } else {
      setRatio(-1);
    }
  }, [volumeLeft, volumeRight]);

  useEffect(() => {
    if (crustVolumeLeft > 0 && crustVolumeRight >= 0) {
      setCrustRatio(Math.max(crustVolumeRight / crustVolumeLeft, 0.01));
    } else {
      setCrustRatio(-1);
    }
  }, [crustVolumeLeft, crustVolumeRight]);

  const handleAboutOnClick = () => {
    showModal(<About />);
  };

  return (
    <div className={styles.molds}>
      <MoldContainer crustVolume={crustVolumeLeft} id={SIDE.Left} molds={molds} setCrustVolume={setCrustVolumeLeft} setVolume={setVolumeLeft} title={localize('mold.recipe')} volume={volumeLeft} />
      <svg className={styles.arrow} viewBox='0 0 198.204 198.204' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M114.799,168.906c-1.582,0-5.261-0.716-5.261-7.383v-30.624H8.181
            c-0.279,0.043-0.655,0.082-1.102,0.082c-1.8,0-3.464-0.68-4.688-1.933C0.805,127.427,0,124.947,0,121.686V74.614
            c0-6.51,4.617-8.231,7.057-8.231h100.34V38.317c0-7.848,3.736-9.019,5.962-9.019c3.572,0,7.129,3.396,7.805,4.08
            c2.441,1.8,66.982,50.455,74.075,57.541c2.577,2.58,3.028,5.175,2.956,6.893c-0.172,4.134-3.357,6.947-3.715,7.258
            l-71.792,59.413C121.91,165.334,118.267,168.906,114.799,168.906z M7.437,125.215l0.476,0.004h107.301v36.3
            c0,0.716,0.057,1.21,0.118,1.535c0.916-0.437,2.426-1.585,3.493-2.716l72.01-59.624c0.426-0.372,1.646-1.75,1.7-3.16
            c0.025-0.859-0.401-1.718-1.299-2.623c-6.811-6.803-73.116-56.778-73.782-57.283c-1.492-1.449-3.26-2.595-4.008-2.666
            c0.032,0.14-0.361,0.981-0.361,3.335v33.741H7.086C6.152,72.094,5.68,72.957,5.68,74.61v47.076c0,2.412,0.591,3.203,0.769,3.389
            c0.068,0.068,0.225,0.229,0.63,0.229L7.437,125.215z'
        />
      </svg>
      <MoldContainer crustVolume={crustVolumeRight} id={SIDE.Right} molds={molds} setCrustVolume={setCrustVolumeRight} setVolume={setVolumeRight} title={localize('mold.yours')} volume={volumeRight} />
      <button className={styles.about} onClick={handleAboutOnClick}>
        {localize('about.label')}
      </button>
      <LanguagePicker />
    </div>
  );
};

Molds.propTypes = {
  setCrustRatio: PropTypes.func.isRequired,
  setRatio: PropTypes.func.isRequired,
};

export default Molds;
